import { Behaviours, FSAReducer } from '@typings/redux';
import { fromApiFormat } from 'utils/api';
import { RESET_STATE } from 'store/store';
import { PasswordSecurityActionType as ActionType } from './passwordSecurity.actionTypes';
import { defaultState, PasswordSecurityState as State } from './passwordSecurity.state';

export const passwordSecurityReducer: FSAReducer<State, ActionType> = (state = defaultState, action) => {
  const behaviours: Behaviours<State, ActionType> = {
    [RESET_STATE]: () => ({
      ...defaultState,
    }),
    [ActionType.FETCH_PASSWORD_SECURITY_REQUEST]: () => {
      return {
        ...state,
        loading: true,
      };
    },
    [ActionType.FETCH_PASSWORD_SECURITY_SUCCESS]: ({ payload }) => {
      return {
        ...state,
        data: fromApiFormat(payload),
        loading: false,
        error: null,
      };
    },
    [ActionType.FETCH_PASSWORD_SECURITY_FAILURE]: ({ error }) => {
      return {
        ...state,
        loading: false,
        error,
      };
    },
  };

  return behaviours[action.type] ? behaviours[action.type](action) : state;
};
